import { createAction } from '@saucelabs/sl-util-redux';

import * as constants from './types';
import { handleLocationMeta } from './../filters/actions';
import * as util from './../../util';
// manage test search box
export const setTestSearchValue = handleLocationMeta(
  createAction(constants.SET_TEST_SEARCH_VALUE), util.searchValueTransformer);
//  manage selected tests list
export const addToSelectedTests = createAction(constants.ADD_TO_SELECTED_TESTS);
export const removeFromSelectedTests = createAction(constants.REMOVE_FROM_SELECTED_TESTS);
export const clearSelectedTests = createAction(constants.CLEAR_SELECTED_TESTS);
